export default __webpack_public_path__ + "b0bfe79636120e74c99fd41fc68659ce.jpg";